export default __webpack_public_path__ + "static/media/person2.89a1b6c9.png";